export class IntercomFacade {
  constructor() {
    this.APP_ID = process.env.INTERCOM_APP_ID
    this._maxAttempts = 30
    this._intervalMs = 500
  }

  init() {
    const interactionButton = document.getElementById('livechat')
    this.bindToButton(interactionButton)
  }

  bindToButton(buttonElement) {
    if(!buttonElement) {
      return
    }

    buttonElement.addEventListener('click', () => {
      buttonElement.classList.add('loading')

      this.load()
        .catch((err) => {
          console.error('Failed to load Intercom:', err)
        })
        .finally(() => {
          buttonElement.classList.remove('loading')
        })
    })
  }

  load() {
    return new Promise((resolve, reject) => {
      if(this._isBooted()) {
        window.Intercom('show')
        resolve()
        return
      }

      window.intercomSettings = {
        app_id: this.APP_ID,
      }

      if(typeof window.Intercom === 'function') {
        window.Intercom('reattach_activator')
        window.Intercom('update', window.intercomSettings)
        resolve()
        return
      }

      this._initializeStub()

      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = `https://widget.intercom.io/widget/${this.APP_ID || ''}`

      script.onload = async () => {
        window.Intercom('show')
        await this._waitForFrame()
        resolve()
      }

      script.onerror = reject

      const firstScript = document.getElementsByTagName('script')[0]
      firstScript.parentNode.insertBefore(script, firstScript)
    })
  }

  _waitForFrame() {
    return new Promise((resolve) => {
      let attempts = 0

      const checkInterval = setInterval(() => {
        const frame = document.querySelector('.intercom-messenger-frame')

        if(frame || attempts > this._maxAttempts) {
          clearInterval(checkInterval)
          resolve()
        }
        attempts++
      }, this._intervalMs)
    })
  }

  _initializeStub() {
    if(typeof window.Intercom === 'function') {
      return
    }

    const intercomStub = function(...args) {
      intercomStub.c(args)
    }
    intercomStub.q = []
    intercomStub.c = function(args) {
      intercomStub.q.push(args)
    }

    window.Intercom = intercomStub
  }

  _isBooted() {
    return window.Intercom && window.Intercom.booted
  }
}

export const initIntercomFacade = () => {
  new IntercomFacade().init()
}
